// components/MobileNavigation/NavigationItem.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { getMainNavIcon } from './IconMapping';
import DropdownContent from './DropdownContent';
import { NavItem } from '../NavbarData';

interface NavigationItemProps {
  item: NavItem;
  activeItem: string;
  onNavClick: (itemId: string) => void;
  hasDropdown: boolean;
  isExpanded: boolean;
  onToggleDropdown: (itemId: string) => void;
  dropdownData?: any[];
}

const NavigationItem: React.FC<NavigationItemProps> = ({
  item,
  activeItem,
  onNavClick,
  hasDropdown,
  isExpanded,
  onToggleDropdown,
  dropdownData
}) => {
  return (
    <div className="border-b border-gray-100 last:border-b-0 pb-2 last:pb-0">
      {/* Main nav item */}
      <div className="flex items-center justify-between">
        <Link
          to={item.to}
          onClick={() => onNavClick(item.id)}
          className={`flex items-center space-x-3 flex-1 px-4 py-3 text-base font-medium border-l-4 transition-all duration-300 rounded-r-lg ${
            activeItem === item.id
              ? "text-navgreen border-navgreen bg-navgreen/10"
              : "text-gray-700 border-transparent hover:text-navgreen hover:bg-gray-50 hover:border-gray-300"
          }`}
        >
          <span className={`${activeItem === item.id ? 'text-navgreen' : 'text-gray-500'}`}>
            {getMainNavIcon(item.id)}
          </span>
          <span>{item.label}</span>
        </Link>
        
        {/* Dropdown arrow button */}
        {hasDropdown && (
          <button
            onClick={() => onToggleDropdown(item.id)}
            className="p-3 ml-2 text-gray-500 hover:text-navgreen hover:bg-gray-100 rounded-lg transition-all duration-200"
          >
            <svg
              className={`w-5 h-5 transition-transform duration-200 ${
                isExpanded ? 'rotate-180' : 'rotate-0'
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        )}
      </div>

      {/* Dropdown content */}
      {hasDropdown && dropdownData && (
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            isExpanded 
              ? 'max-h-[600px] opacity-100 mt-3' 
              : 'max-h-0 opacity-0'
          }`}
        >
          <DropdownContent
            itemId={item.id}
            dropdownData={dropdownData}
            activeItem={activeItem}
            onNavClick={onNavClick}
          />
        </div>
      )}
    </div>
  );
};

export default NavigationItem;